import React, { useRef } from 'react';
var VeltTextCommentToolbar = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-text-comment-toolbar", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltTextCommentToolbar;
